<template>
  <div class="draw_scroll" ref="scrollWrap">
    <div class="draw_list"
         v-infinite-scroll="loadMore"
         infinite-scroll-immediate="false"
         v-if="!isLogin||draw_list.length==0">
      <div class="draw_list_item"
           v-for="(item,index) in sampleSysList"
           :key="index">
        <div class="text">
          <div class="title flex jb">
            <div class="info flex ac">
              <img class="avatar" src="../img/sd.png" alt="">
              <div>
                <p style="margin-bottom: 3px">
                  <span class="topic">Stable Diffusion</span>
                  <span class="tag">AI机器人</span>
                </p>
                <p>
                  <span class="time">{{ item.add_time }}</span>
                </p>
              </div>
            </div>
            <div class="flex ac">
              <p class="delete flex ac"
                 @click="sampleDeleteDraw(item,index)">
                <i class="el-icon-delete"></i><span>删除</span>
              </p>
              <p class="delete flex ac"
                 @click="down_draw_list('sample')">
                <i class="el-icon-download"></i><span>下载</span>
              </p>
            </div>
          </div>
          <div class="desc">
            <p class="zh">{{ item.prompt }}</p>
            <p class="en">{{ item.prompt_en }}</p>
          </div>
          <template v-if="item.progress < 100">
            <div class="detail_loading msg-item-content">
              <circleloading></circleloading>
              <div class="loading_text">Stable Diffusion 绘图需要极大的计算量，请耐心等待...</div>
            </div>
            <div class="creating_progress"
                 v-if="item.progress > 0">
              <div class="progress_bar">
                <div class="progress_line"
                     :style="{'width':item.progress+'%'}"></div>
              </div>
              <div class="progress_percent">{{ item.progress }}%</div>
            </div>
          </template>
          <div v-else>
            <div class="big_img">
              <div class="msg_img_wrap">
                <el-image style="display:block;max-width: 400px;"
                          @click.prevent="clickImage(item.raw_img_url)"
                          :src="item.oss_small_img"
                          :preview-src-list="[item.raw_img_url]">
                </el-image>
                <!-- 高级图片编辑 -->
               <AdvancedPictureEdit :item="item" :soft_type="'sd'" :btn_opt_type="'btn_sd_create'" @editSuccess="editSuccess"></AdvancedPictureEdit>
                <div @click.stop="ImageJump(item.raw_img_url,item.s_w,item.s_h)" class="look_img">查看原图</div>

              </div>
            </div>
            <div class="options">
              <template v-if="item.pic_num==4">
                <div class="options_list flex ac">
                  <p>编辑：</p>
                  <el-tooltip class="item"
                              effect="dark"
                              content="U按钮查看图像，生成所选图像的更大版本并添加更多细节，可进行局部重绘，无损放大，调整创作等。消耗1积分"
                              placement="right-start">
                    <img src="./img/icon_img42.png"
                         class="tips_icon"/>
                  </el-tooltip>
                  <span @click="sampleDrawImg(item, i)"
                        :class="['btn',{'disabled':status>=1}]"
                        v-for="(status,i) in item.u_code">U{{ i + 1 }}</span>
                </div>
              </template>
              <template v-else>
                <div class="options_list flex ac">
                  <p>调整：</p>
                  <el-tooltip class="item"
                              effect="dark"
                              content="以某张图片为基础进行调整，可进行局部重绘，再继续编辑创作，消耗1积分。"
                              placement="right-start">
                    <img src="./img/icon_img42.png" class="tips_icon"/>
                  </el-tooltip>
                  <span class="span" @click="sampleDrawImg('upscale_creative', item)"><img src="./img/wand.png"
                                                                                           alt=" "/>微调（强）</span>
                  <span class="span" @click="sampleDrawImg('upscale_subtle', item)"><img src="./img/wand.png"
                                                                                         alt=" "/>微调（弱）</span>
                </div>
                <!-- 上 下 左 右 拉伸 -->
                <div class="options_list flex ac">
                  <p>放大：</p>
                  <el-tooltip class="item"
                              effect="dark"
                              content="对当前图片进行缩放，消耗1积分"
                              placement="right-start">
                    <img src="./img/icon_img42.png"
                         class="tips_icon"/>
                  </el-tooltip>
                  <span class="span"
                        @click="sampleDrawImg('zoom4x', item)"><img src="./img/magnifier.png"
                                                                    alt=" "/>放大 2x</span>
                  <span class="span"
                        @click="sampleDrawImg('zoom3x', item)"><img src="./img/magnifier.png"
                                                                    alt=" "/>放大 1.5x</span>
                </div>
              </template>
            </div>
            <mgcPop :item="item" :is-first="index" :is-samp="true" :is-sd="true"></mgcPop>
          </div>
        </div>
      </div>
    </div>

    <div class="draw_list"
         v-infinite-scroll="loadMore"
         :infinite-scroll-disabled="noMore || loading">
      <div class="draw_list_item"
           v-for="(item,index) in draw_list"
           :key="index">
        <div class="text">
          <div class="title flex jb">
            <div class="info flex ac">
              <img class="avatar" src="../img/sd.png" alt="">
              <div>
                <p style="margin-bottom: 3px">
                  <span class="topic">Stable Diffusion</span>
                  <span class="tag" v-if="!item.model_version">Ai-Bot</span>
                  <span class="tag" v-else-if="item.model_version">高级编辑 - {{ item.model_version }}</span>
                  <span class="mgTitp" v-else-if="item.img_type=='img_video'">魔法</span>
                </p>
                <p>
                  <span class="time">{{ item.add_time }}</span>
                </p>
              </div>
            </div>
            <div class="flex ac">
              <el-popover placement="bottom-end" width="200" trigger="click" ref="morePopover">
                <div class="more_list">
                  <p class="operate_item flex ac"
                     @click="share_draw_item(item, index)">
                    <img class="share" src="../../views/img/icon_img48.png"/><span>分享</span>
                  </p>
                  <template
                      v-if="(item.img_type=='img_c'||item.img_type=='img_v'||item.img_type.indexOf('zoom')>0||item.img_type.indexOf('_pan_')>0||item.img_type.indexOf('_variation')>0) && item.status==2">
                    <p class="operate_item flex ac"
                       v-if="item.is_public==0"
                       @click="pulic_draw_item(item, index)"><img
                        src="../../views/img/prasie.png"/><span>推荐到广场</span></p>
                    <p class="operate_item flex ac"
                       v-else
                       style="color: #f0b132;"
                       @click="pulic_draw_item(item, index)"><img
                        src="../../views/img/prasie-fill.png"/><span>已推荐到广场</span></p>
                  </template>
                  <p class="operate_item flex ac"
                     @click="delete_draw_list(item.draw_id, index)"><img
                      src="../../views/img/delete.svg"/><span>删除</span></p>
                  <p class="operate_item flex ac"
                     v-if="item.img_type=='img_video'&&item.status=='2'"
                     @click="down_draw_list('video',item,index)">
                    <i class="el-icon-download" style="font-size: 20px"></i><span>下载</span>
                  </p>
                  <p class="operate_item flex ac"
                     v-if="item.img_type=='img_edit'&&item.status=='2'"
                     @click="down_draw_list('video',item,index,'right')">
                    <i class="el-icon-download" style="font-size: 20px"></i><span>下载</span>
                  </p>
                  <p class="operate_item flex ac"
                     v-if="item.img_type!='img_video'&&item.img_type!='img_edit'&&item.status=='2'"
                     @click="down_draw_list('draw',item,index)">
                    <i class="el-icon-download" style="font-size: 20px"></i><span>下载</span>
                  </p>
                </div>
                <div class="more_btn" flex-center slot="reference"><i class="el-icon-more"></i></div>
              </el-popover>
            </div>
          </div>
          <div class="desc">
            <p class="zh">{{ item.prompt }}</p>
          </div>
          <div class="create_error" v-loading="item.regenerateload"
               v-if="(item.status == 3)&&(item.retry_num<3 && item.is_retry==0)">
            <img class="error_icon"
                 src="../../views/img/image_error.png"
                 alt="">
            <div class="error_text">很遗憾，绘画失败 !</div>

            <div class="error_new_btn" @click="error_new_fn(item.draw_id,index)">
              点此重新生成<br/><span class="err_succ_text">（成功率90%以上）</span>
            </div>
            <div class="err_new_tip" v-if="item.show_error">
              失败原因： <span style="color:red;">{{ item.show_error }}</span>
            </div>
            <div class="err_new_tip" v-else>
              涉政、涉黄等请勿提交，会封号。其他问题，请联系<span class="err_tokf" @click="toKf">在线客服</span>
            </div>
          </div>
          <div class="create_error create_error_old"
               v-else-if="(item.status == 3)&&(item.retry_num>=3 || item.is_retry!=0)">
            <!-- 绘画 失败 -->
            <img class="error_icon" src="../../views/img/image_error.png" alt="">
            <div class="error_text">很遗憾，绘画失败 !</div>
            <div class="error_btn" @click="showDefeatPopup">查看失败原因</div>
            <div class="err_new_tip" v-if="item.show_error">
              失败原因： <span style="color:red;">{{ item.show_error }}</span>
            </div>
            <div class="err_new_tip" v-else>
              涉政、涉黄等请勿提交，会封号。其他问题，请联系<span class="err_tokf" @click="toKf">在线客服</span>
            </div>
          </div>
          <template v-else-if="item.status < 2">
            <div class="detail_loading msg-item-content">
              <circleloading></circleloading>
              <div class="loading_text"
                   v-if="item.progress <= 0">Stable Diffusion 正在全力出图中，请稍等...
              </div>
            </div>
            <div class="creating_progress"
                 v-if="item.progress > 0&& item.img_type!='img_video'">
              <div class="progress_bar">
                <div class="progress_line"
                     :style="{'width':item.progress+'%'}"></div>
              </div>
              <div class="progress_percent">{{ item.progress }}%</div>
            </div>
          </template>
          <template v-else>
            <div class="big_img">
              <div class="msg_img_wrap">
                <el-image :src="item.img_url"
                          :preview-src-list="[item.raw_img_url]">
                </el-image>
                <!-- 图片索引 -->
                <ImgIndex v-show="item.pic_num==4" :item_width="item.s_w" :item_height="item.sh"></ImgIndex>
                <div @click.stop="ImageJump(item.raw_img_url,item.s_w,item.s_h)" class="look_img">查看原图</div>
              </div>
              <!-- 高级图片编辑 -->
             <AdvancedPictureEdit :item="item" :soft_type="'sd'" :btn_opt_type="'btn_sd_create'" @editSuccess="editSuccess" :topHeight="-10"></AdvancedPictureEdit>
            </div>
            <div class="options" v-if="item.menu_type==1">
              <!-- U V C -->
              <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                <el-tooltip class="item"
                            effect="dark"
                            content="U按钮查看图像，生成所选图像的更大版本并添加更多细节，可进行局部重绘，无损放大，调整创作等。消耗4积分"
                            placement="right-start">
                  <img src="../../views/img/icon_img42.png"
                       class="tips_icon"/>
                </el-tooltip>
                <span @click="drawImgUV('u',i, item, status)"
                      :class="['btn',{'disabled':status>=1}]"
                      v-for="(status,i) in item.u_code">U{{ i + 1 }}</span>
                <span @click="imgRedraw(item)"
                      :class="['btn', 'redraw']"><img src="../../views/img/icon_img41.png"
                                                      alt=" "/></span>
              </div>

              <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                <el-tooltip class="item"
                            effect="dark"
                            content="V按钮创建所选网格图像的细微变化，创建变体会生成与所选图像的整体风格和构图相似的新图像网格。消耗4积分"
                            placement="right-start">
                  <img src="../../views/img/icon_img42.png"
                       class="tips_icon"/>
                </el-tooltip>
                <span @click="viewImg(item,1)">C1</span>
                <span @click="viewImg(item,2)">C2</span>
                <span @click="viewImg(item,3)">C3</span>
                <span @click="viewImg(item,4)">C4</span>
              </div>
              <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                <mgcPop :item="item" :btn_opt_type="'btn_sd_create'" :is-first="index" :is-mj="true" @magData="mgcPFn"></mgcPop>
              </div>
            </div>
            <div class="options" v-if="item.menu_type == 3">
              <!-- U V C -->
              <div class="options_list flex ac f_w">
                <el-tooltip class="item"
                            effect="dark"
                            content="以某张图片为基础进行调整，可进行局部重绘，再继续编辑创作，消耗4积分。"
                            placement="right-start">
                  <img src="../../views/img/icon_img42.png"
                       class="tips_icon"/>
                </el-tooltip>

                <span class="span ds1"
                      @click="drawImgZoom('upscale_creative', item)">
                    <img src="../../views/img/wand.png" alt=" "/>微调(强)
                  </span>
                <span class="span" @click="drawImgZoom('upscale_subtle', item)">
                    <img src="../../views/img/wand.png" alt=" "/>微调(弱)
                  </span>
                <!--                  <span class="span" @click="openRemoval(item)">-->
                <!--                    <img src="../../views/img/pen.png" alt=" " />-->
                <!--                    局部重绘-->
                <!--                  </span>-->
              </div>
              <div class="options_list flex ac">
                <el-tooltip class="item" effect="dark" content="对当前图片进行缩放，消耗4积分"
                            placement="right-start">
                  <img src="../../views/img/icon_img42.png" class="tips_icon"/>
                </el-tooltip>
                <span class="span" @click="drawImgZoom('upscale_4x', item)">
                    <img src="../../views/img/magnifier.png" alt=" "/>
                    放大 2.5x
                  </span>
                <span class="span" @click="drawImgZoom('upscale_3x', item)">
                    <img src="../../views/img/magnifier.png" alt=" "/>
                    放大 2x
                  </span>
                <span class="span" @click="drawImgZoom('upscale_2x', item)">
                    <img src="../../views/img/magnifier.png" alt=" "/>
                    放大 1.5x
                  </span>
              </div>
              <div class="options_list flex ac" v-if="item.img_type!='img_video'">
                <mgcPop :item="item" :btn_opt_type="'btn_sd_create'" :is-first="index" :is-mj="false" @magData="mgcPFn"></mgcPop>
              </div>


            </div>


          </template>
        </div>
      </div>
    </div>
    <popup ref="defeatPopup"
           type="center"
           @close="defeatPopClose">
      <div class="defeat_popup">
        <div class="popup_title">失败原因如下</div>
        <div class="popup_content">
          <div class="content_items">
            <div class="item_question">问：为什么Stable Diffusion绘画出图会比较慢？</div>
            <div class="item_answer">
              答：因为Stable Diffusion与其他绘画软件不同，一次性生成四张高清图片，通常仅需约5分钟完成，算下来速度相当快！
            </div>
          </div>
          <div class="content_items">
            <div class="item_question">问：为什么绘画会提示失败？</div>
            <div class="item_answer">
              答：因为Stable Diffusion绘画全部为Ai原创，可能会出现违规低俗内容，这些图片会被系统自动过滤删除，与您无关！
            </div>
          </div>
        </div>
        <button class="close_btn"
                @click="defeatPopClose">好的，我知道了
        </button>
      </div>
    </popup>
    <!-- 推荐到广场 -->
    <Recommend v-if="current_draw&&show_recommend_popup"
               :draw_item="current_draw"
               @close="recommendCallBack"
               ref="recommend"></Recommend>
    <!-- 分享 -->
    <ShareDraw v-if="current_draw&&show_sharedraw_popup"
               :draw_item="current_draw"
               @close="show_sharedraw_popup=false"
               ref="ShareDraw"></ShareDraw>
    <!--采集-->
    <drawCateEdit ref="drawCateEdit"
                  @close="caiJiOk"></drawCateEdit>

    <!-- 反馈弹窗 -->
    <FeedBack v-if="current_draw&&show_feedback_popup"
              :draw_item="current_draw"
              @close="show_feedback_popup=false"
              ref="feedback"></FeedBack>
    <popup ref="viewPopup"
           type="center"
           @close="popClose">
      <img class="view_img"
           :src="view_img_url"
           style="width:100% !important;height:100% !important;">
      <!-- <el-image style="display:block;max-width: 400px;" :src="view_img_url" :preview-src-list="[view_img_url]"></el-image> -->
    </popup>
    <canvas ref="localCanvas"
            style="display: none;"
            useCORS="true"
            allowTaint="true"></canvas>
    <el-image ref="previewImg" style="display: none;" :src="view_img_url" :preview-src-list="[view_img_url]"></el-image>
    <popup ref="imageManipulation" type="center" @close="drawImgZoom('','','close')">
      <div class="Image_manipulation">
        <div class="clear" @click="drawImgZoom('','','close')">
          <i class="el-icon-error"></i>
        </div>
        <!-- <img :src="liveAlone" alt=""/> -->
        <el-image style="display:block;max-width: 800px;"
                  @click.prevent="clickImage(liveAlone)"
                  :src="liveAlone"
                  :preview-src-list="[liveAlone]">
        </el-image>
      </div>
    </popup>
    <faceVerifyPopup ref="faceVerifyPopup"></faceVerifyPopup>
    <div class="drowPopB" v-show="isDrowShow">
      <div class="imgRemovalPopup">
        <div class="imgbox_top">
          <div>请擦拭需要涂抹的区域</div>
          <div style="cursor: pointer;" @click="saveImage(0)"><i class="el-icon-error"></i></div>
        </div>
        <div class="imgbox_center">
          <div class="apply">
            <span @click="toggleMode('draw')" :class="mode == 'draw' ? 'spancol' : ''">涂抹</span>
            <span @click="toggleMode('erase')" :class="mode == 'erase' ? 'spancol' : ''"
                  style="margin-left:10px;">擦拭涂抹</span>
          </div>
          <br/>
          <div class="brush">
            <span>画笔大小</span>
            <div class="slider">
              <el-slider v-model="brushSize"></el-slider>
            </div>
            <div style="width: 20px;">{{ brushSize }}</div>
          </div>
          <div class="brush scoBox">
            <!-- <span>比例</span>
            <div class="addBtn" @click="updateScale(0)">
              <img src="../tool/img/jian.svg" alt="">
            </div> -->
            <!-- <div class="aocText">{{ parseInt(scale * 100) }}%</div>
            <div class="addBtn" @click="updateScale(1)">
              <img src="../tool/img/jia.svg" alt="">
            </div> -->
          </div>
          <div class="clear_btn" @click="clearCanvas()">
            <div>清空</div>
          </div>
        </div>
        <div class="canvas_region">
          <div class="canvas-wrapper">
            <img id="imageOrigin" :src="form.iw_url" @load="onImageLoad"
                 :style="{ left: position.x + 'px', top: position.y + 'px',cursor:Dragging_btn?'move':'', }"
                 alt="Image" ref="canvasRecord">
            <canvas ref="canvasDisplay"
                    :style="{ left: position.x + 'px',
                    top: position.y + 'px',
                    cursor:Dragging_btn?'move':'',
                      }"
                    :width="originWidth" :height="originHeight" id="canMask">
            </canvas>
            <div class="brush scoBox">
              <!-- <div @click="Dragging_btn=!Dragging_btn" :class="['Dragging',Dragging_btn?'ok_drag':'']">拖动</div> -->
              <div class="addBtn" @click="updateScale(0)">
                <img src="../img/jian.svg" alt="">
              </div>
              <div class="aocText">{{ parseInt(scale * 100) }}%</div>
              <div class="addBtn" @click="updateScale(1)">
                <img src="../img/jia.svg" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="complete_btn">
          <div class="inp_Redraw">
            <input v-model="form.prompt" type="text" placeholder="请输入重绘内容">
          </div>
          <div class="fulfil_btn" @click="saveImage(1)">完成</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import popup from "COMPONENTS/Popup.vue"
import circleloading from "COMPONENTS/CircleLoading.vue"
import FeedBack from '@/components/FeedBack.vue'
import Recommend from '@/components/Recommend.vue'
import ShareDraw from '@/components/ShareDraw.vue'
import drawCateEdit from '@/components/DrawCateEdit'
import TipsWords from '@/components/TipsWords'
import mgcPop from "COMPONENTS/mgcPop.vue"
import faceVerifyPopup from "COMPONENTS/FaceVerifyPopu.vue";
import AdvancedPictureEdit from '@/components/AdvancedPictureEdit.vue'
import ImgIndex from '@/components/ImgIndex.vue'
import utils from "@/utils";
export default {
  components: {mgcPop, popup, circleloading, FeedBack, Recommend, ShareDraw, drawCateEdit, TipsWords, faceVerifyPopup,AdvancedPictureEdit,ImgIndex},
  props: ['sampleList'],
  data() {
    return {
      //显示用户反馈
      show_feedback_popup: false,
      //显示推荐到广场
      show_recommend_popup: false,
      //显示分享弹窗
      show_sharedraw_popup: false,
      current_draw: null,//当前选中的记录
      draw_list: [],
      noMore: false, // 是否还有数据
      loading: false, // 正在请求数据
      max_mj_id: 0, // 最小的ID
      checkIds: [], // 生成中的需要检测的ID
      timer: null,
      sampleSysList: [], // 系统样例
      sampleUserList: [], // 用户样例
      sampleTimer: null,
      view_img_url: "",
      page: 1,
      liveAlone: '',

      isDrowShow: false,
      mode: 'draw', // 'draw' 或 'erase'
      brushSize: 10,
      scale: 0, // 缩放比例
      originWidth: 0,
      originHeight: 0,
      drawnPath: [],
      clearPath: [],//记录清除轨迹
      fileApi: FILE_API_SERVER,
      form: {
        // 上传图片
        iw_url: '',// 局部调整弹窗图片
        // iw_url: 'https://mjimg.zhanjuzhe.cn/mj_tool/202504/22/20250422170645838015.png',// 局部调整弹窗图片
        // iw_urls: 'https://mjimg.zhanjuzhe.cn/mj_tool/202504/22/20250422170659960514.png',
        prompt: '', // 重绘文字
        parent_draw_id: '',
        img_type: 'img_region_variation',
      },
      position: {x: null, y: null},
      Dragging_btn: false,
      canvasHeight: 0,
    }
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
    isLogin() {
      return this.$store.state.isLogin;
    }
  },
  created() {
    console.log("fetchDataList create")
    this.sampleUserList = JSON.parse(localStorage.getItem('sampleUserList') || "[]")

    this.fetchDataList()
    this.fettchSampleList()
  },
  methods: {
    // 高级图片编辑成功
    editSuccess(data){
      this.max_mj_id = 0
      this.draw_list.unshift(data)
      this.scrollToTop();
      this.checkIds.push(data.draw_id)
      this.fetchMsg()
    },
    handleResize() {
      // this.windowHeight = window.innerHeight;
      // this.canvasHeight = this.windowHeight
      console.log('window.innerHeight', window.innerHeight)
      if (window.innerHeight >= 900) {
        this.canvasHeight = 400
      } else if (window.innerHeight < 900 && window.innerHeight > 850) {
        this.canvasHeight = 600
      } else if (window.innerHeight < 850 && window.innerHeight > 800) {
        this.canvasHeight = 500
      } else if (window.innerHeight < 800 && window.innerHeight > 750) {
        this.canvasHeight = 400
      } else {
        this.canvasHeight = 400
      }
    },
    error_new_fn(id, ind) {
      //{params:{id}}
      this.draw_list[ind].regenerateload = true
      this.$forceUpdate()
      this.$http.post('/front/aimj/draw/retry/', {id}).then(res => {
        if (res.status == 200) {
          this.draw_list[ind].is_retry += 1
          this.draw_list[ind].regenerateload = false
          this.scrollToTop();
          this.$message.success('重新生成创建成功');
          this.draw_list.unshift(res.data)
          this.checkIds.push(res.data.draw_id)
          this.fetchMsg()
        } else {
          this.draw_list[ind].regenerateload = false
          this.$forceUpdate()
          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/member')
            }).catch(() => {

            });
            return
          } else if (message == "no_face_verify") {
            // 实名认证
            this.$refs.faceVerifyPopup.show()
            return
          } else if (message == 'retry_num_max') {
            message = '已超出最大重试次数'
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
          // if(res.message=='upgradevip'){
          //   this.$message.error(res.data.msg)
          // }
          // this.$message.error(res.data.msg)
        }
      }).catch(err => {
        this.draw_list[ind].regenerateload = false
        this.$forceUpdate()
        let message = res.message;
        if (message == "vip_expire") {
          // VIP 过期了
          this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "no_open_vip") {
          // 未开通 VIP
          this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
            confirmButtonText: '开通会员',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "no_gift_score") {
          // 积分不足
          this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "upgradevip") {
          // 队列已满
          this.$confirm(res.data.msg, '提示', {
            confirmButtonText: '升级套餐',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
            this.$router.push('/member')
          }).catch(() => {

          });
          return
        } else if (message == "no_face_verify") {
          // 实名认证
          this.$refs.faceVerifyPopup.show()
          return
        } else if (message == 'retry_num_max') {
          message = '已超出最大重试次数'
        }
        if (message.indexOf("您提问的内容包含违禁词") > -1) {
          message = "内容可能违反国家政策，请重新输入";
        }
        this.$confirm(message, '提示', {
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
        })
      })
    },
    toKf() {
      utils.tokf()
      // window.open('/linkus')
    },
    mgcPFn(data) {
      this.submitQuestion(data)
    },
    fettchSampleList() {
      // 获取样例数据
      this.$http.get('/front/aimj/draw/sample/', {
        params: {
          draw_soft: 'sd',
          page: this.page,
          size: 10,
        }
      }).then((res) => {
        console.log('j/draw/sample/\'', res.data)
        this.sampleSysList = this.sampleSysList.concat(res.data)
        this.sampleSysList.forEach(item => {
          item.menu_type = 3
        })
      })
      // this.$http.get('/front/aisd/draw/sample/', {
      //   params: {
      //     max_mj_id: this.max_mj_id,
      //     page: this.page,
      //   }
      // }).then((res) => {
      //   this.noMore = false
      //   this.loading = false
      //   let _list = res.data.item_list
      //   this.sampleSelectList = _list.slice(_list.length - 20, _list.length)
      //
      //   if (this.sampleUserList.length > 0) {
      //     this.sampleSysList = this.sampleUserList
      //   } else {
      //     this.sampleSysList = this.sampleSysList.concat(_list)
      //   }
      // })
    },
    sampleDrawImg() {
      // 样例图片 U V 处理
      this.checkLogin()
    },
    sampleDeleteDraw(item, index) {
      // 样例图片 删除
      if (!this.checkLogin()) {
        return
      }
      this.$confirm('确定删除该创作记录吗，删除后不可恢复', '提示', {
        type: 'warning',
        customClass: 'confirm_box'
      }).then(() => {
        this.sampleSysList.splice(index, 1)
        let j = -1
        for (let i = 0; i < this.sampleUserList.length; i++) {
          console.log(this.sampleUserList[i].draw_id, item.draw_id)
          if (this.sampleUserList[i].draw_id == item.draw_id) {
            j = i
          }
        }
        if (j > -1) {
          this.sampleUserList.splice(j, 1)
          localStorage.setItem("sampleUserList", JSON.stringify(this.sampleUserList))
        }
      }).catch(() => {
      })
    },
    //选择提示词
    choose_tips_item() {
      // 样例 选中
      this.scrollToTop()
      if (this.sampleTimer !== null) {
        return
      }
      this.sampleTimer = setInterval(() => {
        let createNum = 0; // 需要生成个数
        this.sampleSysList.forEach(e => {
          if (e.progress < 100) {
            createNum += 1
            let num = parseInt(Math.random() * 10);
            if (e.progress + num > 100) {
              e.progress = 100
              this.sampleUserList.forEach(m => {
                if (e.draw_id == e.draw_id) {
                  e.progress = 100
                  localStorage.setItem("sampleUserList", JSON.stringify(this.sampleUserList))
                }
              })
              this.scrollToTop()
            } else {
              e.progress += num
            }
          }
        })
        if (createNum == 0) {
          clearInterval(this.sampleTimer)
          this.sampleTimer = null
          this.scrollToTop()
        }
      }, 500)
    },
    checkLogin() {
      // 检查登录状态
      if (!this.isLogin) {
        this.$confirm('根据《中国生成式人工智能管理办法》相关规定，利用AI生成内容必须落实主体登记，请您扫码登录后再使用。', '提示', {
          confirmButtonText: '立即登录',
          cancelButtonText: '关闭',
          type: 'warning',
          customClass: 'confirm_box'
        }).then(() => {
          this.$store.commit('setUserInfo', null)
          this.$store.commit('setIsLogin', false)
          this.$store.commit('setShowLogin', true)
        }).catch(() => {
        });
        return false;
      } else {
        return true;
      }
    },

    loadMore() {
      // 加载更多数据
      this.noMore = true
      this.loading = true
      if (this.isLogin) {
        // 登录请求样例
        this.fetchDataList()
      } else {
        // 未登录请求样例
        // this.pageType = false
        let number = this.sampleSysList.length % 10 === 0
        if (!(this.sampleSysList.length % 10 === 0)) {
          console.log(111111)
          this.$message.warning('样例已全部加载')
          return
        }
        if (this.page >= 3) {
          console.log('已经加载完成')
          this.$message.warning('样例已全部加载')
          return
        }
        this.page = this.page + 1
        this.fettchSampleList()
      }
    },
    fetchDataList() {
      // 对话内容
      this.loading = true
      this.$http.get('/front/aisd/user/draw/', {
        params: {
          max_mj_id: this.max_mj_id,
          softs: 'sd',
        }
      }).then((res) => {
        if (res.status == 200) {
          if (res.data.item_list.length > 0) {
            if (this.max_mj_id == 0) {
              res.data.item_list.forEach(e => {

                if (e.status <= 1 || (e.status == 2 && e.local_img_url == "")) {
                  this.checkIds.push(e.draw_id)
                }
              })
              this.fetchMsg()
            }
            this.max_mj_id = res.data.item_list[res.data.item_list.length - 1].draw_id
            res.data.item_list.forEach(item => {
              if (!item.regenerateload) {
                item.regenerateload = false
              }
            })
            this.draw_list = this.draw_list.concat(res.data.item_list)
            // this.draw_list[0].menu_type = 1
          } else {
            this.noMore = true
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    submitQuestion(data, parent_msg_code, i) {
      if (this.sending) {
        this.$message({
          message: '正在任务，不要重复提交，请稍后！',
          type: 'waring'
        });
        return
      }
      this.sending = true;
      // 提交问题
      data.source = "pc";
      this.$http.post('/front/aisd/draw/', data).then((res) => {
        if (res.status == 200) {
          this.inputVal = "";
          if (data.img_type != 'img_video') {
            this.draw_list.splice(0, 0, res.data.draw)
            this.scrollToTop();
            this.checkIds.push(res.data.draw.draw_id)
          } else {
            this.draw_list.unshift(...res.data.draw);
            this.scrollToTop();
            res.data.draw.forEach(mg_id => {
              this.checkIds.push(mg_id.draw_id)
            })
          }
          // this.draw_list.unshift(res.data.draw);
          // this.scrollToTop();
          // // 发送消息
          // this.checkIds.push(res.data.draw.draw_id)

          this.$message({
            message: '创建任务成功！',
            type: 'success'
          });

          this.fetchMsg();
        } else {

          let message = res.message;
          if (message == "vip_expire") {
            // VIP 过期了
            this.$confirm("您的会员已经过期，如需继续使用该功能请重新开通会员", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "no_open_vip") {
            // 未开通 VIP
            this.$confirm("该功能为会员专享功能，请升级会员后使用", '提示', {
              confirmButtonText: '开通会员',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "no_gift_score") {
            // 积分不足
            this.$confirm("您的积分已经用完，如需继续使用该功能请购买积分或升级套餐", '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          } else if (message == "upgradevip") {
            // 队列已满
            this.$confirm(res.data.msg, '提示', {
              confirmButtonText: '升级套餐',
              cancelButtonText: '取消',
              type: 'warning',
              customClass: 'confirm_box'
            }).then(() => {
              this.$router.push('/mjmember')
            }).catch(() => {

            });
            return
          }
          if (message.indexOf("您提问的内容包含违禁词") > -1) {
            message = "内容可能违反国家政策，请重新输入";
          }
          this.$confirm(message, '提示', {
            type: 'warning',
            customClass: 'confirm_box'
          }).then(() => {
          })
        }
      }).finally(() => {
        this.sending = false;
      })
    },
    fetchMsg() {
      if (this.checkIds.length == 0) {
        return
      }
      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        this.$http.post('/front/aimj/draw/check/', {ids: this.checkIds}).then((res) => {
          if (res.status == 200) {
            let item_list = res.data.item_list;
            let draw_id = 0;
            item_list.forEach(e => {
              draw_id = e.draw_id
              let item = this.draw_list.filter((obj) => obj.draw_id == draw_id)[0];

              item.status = e.status
              item.progress = e.progress;
              item.s_w = e.s_w
              item.s_h = e.s_h
              item.pic_num = e.pic_num
              item.retry_num = e.retry_num
              item.is_retry = e.is_retry
              item.menu_type = e.menu_type
              item.show_error = e.show_error

              // item.img_url = e.img_url;
              if (e.status > 2) {
                // 删除生成成功或失败的
                console.log("删除生成成功或失败的", e)
                if (e.show_error) {
                  this.$message.error(e.show_error)
                }
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
              }
              if (e.status == 2 && e.local_img_url != "") {
                // 生成成功 并下载本地
                console.log("生成成功 并下载本地", e)
                this.checkIds = this.checkIds.filter(i => i !== draw_id)
                item.img_url = e.local_img_url
                item.raw_img_url = e.raw_img_url
                item.single_img_url = e.single_img_url
                item.single_img_url2 = e.single_img_url2
                item.single_img_url3 = e.single_img_url3
                item.single_img_url4 = e.single_img_url4
                item.is_retry = e.is_retry
                this.scrollToTop();
                // 创作成功检测是否弹出挽留弹窗
                utils.checkContinuePop(this.$store.state.userInfo)
              }
              if (e.status == 3) {
                // 绘画失败
              }
            })
            this.$forceUpdate()
          }
          if (this.checkIds.length == 0) {
            clearInterval(this.timer);
          }
        }).catch((res) => {
          console.log(res)
          clearInterval(this.timer);
        })
      }, 3000)
    },
    imgRedraw(item) {
      // 重新绘画
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_redraw",
        img_index: 1
      }
      this.submitQuestion(data, [], 1);
    },
    drawImgUV(type, i, item, status) {
      // 对图片进行 U V 操作
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      if (status != 0) return
      item[type + '_code'][i] = 2;
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_" + type,
        img_index: i + 1
      }
      this.submitQuestion(data, item[type + '_code'], i);
    },
    drawImgZoom(type, item) {
      // 对图片进行 zoom 操作
      if (item.status != 2) {
        this.$message({
          message: '任务还未完成，不能操作！',
          type: 'waring'
        });
        return
      }
      if(!utils.setOptData(this.userInfo,'btn_sd_create')){
          return
      }
      let data = {
        parent_draw_id: item.draw_id,
        img_type: "img_" + type,
        img_index: 1
      }
      console.log(data)
      this.submitQuestion(data, [], 0);
    },

    viewImg(item, type) {
      let img_url = item.raw_img_url
      const canvas = this.$refs.localCanvas;
      let that = this
      var imgRaw = new Image();
      imgRaw.src = img_url
      imgRaw.setAttribute('crossOrigin', 'anonymous');
      imgRaw.onload = function () {
        var arr = []
        let canvasWidth = imgRaw.width / 2; // Assuming split in half
        let canvasHeight = imgRaw.height / 2; // Adjust as needed
        for (var i = 0; i <= 4; i++) {
          canvas.width = canvasWidth
          canvas.height = canvasHeight

          const ctx = canvas.getContext('2d');
          const x = i % 2 === 0 ? 0 : canvasWidth;
          const y = Math.floor(i / 2) === 0 ? 0 : canvasHeight;

          ctx.drawImage(imgRaw, x, y, canvasWidth, canvasHeight, 0, 0, canvasWidth, canvasHeight);

          const base64 = canvas.toDataURL('image/jpeg');
          arr.push(base64);
        }

        that.view_img_url = arr[type - 1]
        // that.$refs.viewPopup.show();
        that.$refs.previewImg.clickHandler();
        that.$nextTick(() => {
          let wrapper = document.getElementsByClassName(
              "el-image-viewer__actions__inner"
          );
          if (wrapper.length > 0) {
            let downImg = document.createElement("i");
            downImg.setAttribute("class", "el-icon-download");
            wrapper[0].appendChild(downImg);
            downImg.addEventListener("click", () => {
              var a = document.createElement("a"); // 生成一个a元素
              var event = new MouseEvent("click"); // 创建一个单击事件
              a.download = Date.now(); // 设置图片名称
              a.href = that.view_img_url; // 将生成的URL设置为a.href属性
              a.dispatchEvent(event); // 触发a的单击事件
            });
          }
        })
      }
    },
    previewImg(url) {
      this.view_img_url = url;
      this.$refs.viewPopup.show();
    },
    popClose() {
      this.$refs.viewPopup.close();
    },
    scrollToTop() {
      this.$nextTick(() => {
        let scrollWrap = this.$refs.scrollWrap;
        scrollWrap.scrollTop = 0;
      })
    },
    delete_draw_list(id, index) {
      // 删除
      this.$confirm('确定删除该创作记录吗，删除后不可恢复？', '提示', {
        type: 'warning',
        customClass: 'confirm_box'
      }).then(() => {
        this.$http.delete(`/front/aimj/draw/${id}/`).then((res) => {
          this.draw_list.splice(index, 1)
        })
      })

    },
    down_draw_list(type,item,index,position) {
      // 下载
      if(type=='sample'){
        this.$message.warning('当前样例禁止下载，请生成后重试')
      } else if(type=='video'){
        this.$http.get(`/front/aimj/draw/video/${item.draw_id}/`,).then(res => {
          if (res.status == '200') {
            window.location.href = res.data.url
          } else {
            let message = res.message
            utils.createErrTip(message)
          }
        }).catch(err=>{
          let message = err.message;
          utils.createErrTip(message)
        }).finally(() => {
          this.loading = false
        })
      }else{
        console.log('作品下载')
        this.$http.get(`/front/aimj/draw/down/${item.draw_id}/?${position!=undefined?'nano_position='+position:''}`,).then(res => {
          if (res.status == '200') {
            window.location.href = res.data.url
          } else {
            let message = res.message
            utils.createErrTip(message)
          }
        }).catch(err=>{
          let message = err.message;
          utils.createErrTip(message)
        }).finally(() => {
          this.loading = false
        })
      }

    },
    showDefeatPopup() {
      this.$refs.defeatPopup.show();
    },
    defeatPopClose() {
      this.$refs.defeatPopup.close();
    },
    share_draw_item(item, index) {
      this.current_draw = item
      this.show_sharedraw_popup = true;
      this.$refs.morePopover[index].doClose();
    },
    recommendCallBack(draw_id) {
      // 推荐到广场 回调
      this.show_recommend_popup = false;
      if (draw_id) {
        this.draw_list.forEach(e => {
          if (e.draw_id == draw_id) {
            e.is_public = 1
          }
        })
      }
    },
    pulic_draw_item(item, index) {
      // 点击弹出推荐到广场
      if (item.is_public == 0) {
        this.current_draw = item
        this.show_recommend_popup = true;
        this.$refs.morePopover[index].doClose();
      } else {
        item.is_public = 0
        this.$http.patch(`/front/aimj/user/draw/${item.draw_id}/`, {
          'action': 'public',
          data: {'sys_cate_id': 0}
        }).then((res) => {
          this.$message({
            message: '取消推荐成功',
            type: 'success'
          });
        }).finally((res) => {
          this.close()
        })
      }

    },
    fave_draw_item(draw, index) {
      // 采集
      this.$refs.drawCateEdit.show(draw, 1)
      this.$refs.morePopover[index].doClose();
    },
    //点击弹出反馈弹窗
    handle_show_feedback_popup(item) {
      this.current_draw = item
      this.show_feedback_popup = true
    },
    async getJSON() {
      let url = 'https://mjimg.zhanjuzhe.cn/media/202407/19/1721384316144.png';
      try {
        let response = await fetch(url);
        return await response.json();
      } catch (error) {
        console.log('Request Failed', error);
      }
    },
    caiJiOk(item) {
      // 采集回调
      this.draw_list.forEach(e => {
        if (e.draw_id == item.draw_id) {
          e.cate_id = 8
        }
      })
    },
    clickImage(raw_img_url) {
      // 下载图片
      this.$nextTick(() => {
        let wrapper = document.getElementsByClassName(
            "el-image-viewer__actions__inner"
        );
        if (wrapper.length > 0) {
          let downImg = document.createElement("i");
          downImg.setAttribute("class", "el-icon-download");
          wrapper[0].appendChild(downImg);
          downImg.addEventListener("click", () => {
            console.log(raw_img_url)
            var image = new Image();
            // 解决跨域 Canvas 污染问题
            image.setAttribute("crossOrigin", "anonymous");
            image.onload = function () {
              var canvas = document.createElement("canvas");
              canvas.width = image.width;
              canvas.height = image.height;
              var context = canvas.getContext("2d");
              context.drawImage(image, 0, 0, image.width, image.height);
              var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

              var a = document.createElement("a"); // 生成一个a元素
              var event = new MouseEvent("click"); // 创建一个单击事件
              a.download = Date.now(); // 设置图片名称
              a.href = url; // 将生成的URL设置为a.href属性
              a.dispatchEvent(event); // 触发a的单击事件
            };
            image.src = raw_img_url;
            //this.downloadImage(raw_img_url, "aaa")
            //这里写下载图片的方法
            // const content = document.querySelector('.el-image-viewer__img'); // 获取需要保存为图片的 DOM 元素
            // html2canvas(content).then(canvas => {
            //     setTimeout(() => {
            //         // 将 Canvas 转换为图片数据
            //         const imageData = canvas.toDataURL('image/png');
            //         // 创建一个 <a> 元素，并设置 href 属性为图片数据
            //         const a = document.createElement('a');
            //         a.href = imageData;
            //         a.download = Date.now() + '.png'; // 设置下载文件名
            //         a.click(); // 模拟点击下载
            //     }, 500)
            // },);
            // const canvas = this.$refs.localCanvas;
            // var imgRaw = new Image();
            // imgRaw.src = raw_img_url
            // imgRaw.setAttribute('crossOrigin', 'anonymous');
            // imgRaw.onload = function () {
            //     canvas.width = imgRaw.width
            //     canvas.height = imgRaw.height
            //     const ctx = canvas.getContext('2d');
            //     ctx.drawImage(imgRaw, 0, 0);
            //     const imageData = canvas.toDataURL('image/jpeg');
            //     const a = document.createElement('a');
            //     a.href = imageData;
            //     a.download = Date.now() + '.png'; // 设置下载文件名
            //     a.click(); // 模拟点击下载
            // }
          });
        }
      });
    },
    ImageJump(imgurl, s_w, s_h) {
      // window.open(imgurl + '?width=' + s_w + '&height=' + s_h, '_blank');
      window.open(imgurl, '_blank');
    },
    // 局部重绘
    openRemoval(item) {
      // 打开弹窗
      this.originWidth = item.s_w
      this.originHeight = item.s_h
      this.form.iw_url = item.raw_img_url
      this.form.parent_draw_id = item.draw_id
      this.form.prompt = item.prompt
      this.form.img_type = 'img_region_variation'
      this.isDrowShow = true
      // this.$nextTick(() => {
      //   this.removelDraw()
      // });
    },
    saveImage(num) {

      if (num) {
        // let this = this
        setTimeout(() => {
          const canvas = this.$refs.canvasDisplay;
          // 获取mask
          canvas.toBlob((blob) => {
            const file = new File([blob], 'my-drawing.png', {type: 'image/png'})
            const formData = new FormData();
            formData.append('file', file,);
            this.$http.post(this.fileApi + '/api/front/upload/?fdir=mj_iw', formData).then(res => {
              this.form.iw_url = res.data.file_full_url
              this.isDrowShow = false
              this.clearMaskShow = true
              // this.submitQuestion()
              // 提交局部问题
              this.submitQuestion(this.form)


            })
          })
        });
      } else {
        this.clearCanvas()
        this.isDrowShow = false
        this.form.data.iw_url = ''
        this.position.x = null
        this.position.y = null
        this.Dragging_btn = false
      }

    },
    onImageLoad() {
      console.log('onImageLoad')
      const img = this.$refs.canvasRecord;
      this.originWidth = img.naturalWidth || img.width
      this.originHeight = img.naturalHeight || img.height
      this.handleResize()
      this.removelDraw()

    },
    removelDraw() {
      console.log('removelDraw')

      const imgOr = document.getElementById('imageOrigin');
      const canOr = document.getElementById('canMask');
      const naturalWidth = this.originWidth;
      const naturalHeight = this.originHeight;
      const maxDimension = this.screenWidth; // 最大宽高限制
      const canvas2 = this.$refs.canvasDisplay
      this.canvasDisplay = canvas2.getContext('2d');
      this.scale = 1; // 初始缩放比例
      if (naturalWidth > maxDimension || naturalHeight > maxDimension) {
        const widthScale = maxDimension / naturalWidth;
        const heightScale = maxDimension / naturalHeight;
        this.scale = Math.min(widthScale, heightScale);
        // scale = Math.max(widthScale, heightScale);
      } else {
        this.scale = 1; // 如果图片尺寸小于限制，则保持原始大小
      }
      imgOr.style.transform = `scale(${this.scale})`;
      canOr.style.transform = `scale(${this.scale})`

      this.enableDrawing();
      this.brushSize = 15
    },
    enableDrawing(ctx) {
      let isDrawing = false;
      const canvas2 = this.$refs.canvasDisplay;
      // const canvasYes = this.$refs.yesMask;
      this.canvasDisplay = canvas2.getContext('2d');
      // 鼠标画板按下
      canvas2.addEventListener('pointerdown', (e) => {
        isDrawing = true;
        this.canvasDisplay.beginPath();
        this.canvasDisplay.moveTo(e.offsetX, e.offsetY);
      });

      // 鼠标画板移动
      canvas2.addEventListener('pointermove', (e) => {
        if (isDrawing == true && this.mode != 'erase') {
          this.drawnPath.push({x: e.offsetX, y: e.offsetY})
          this.drawCircle(this.canvasDisplay, e.offsetX, e.offsetY, 'rgb(255,255,255)');
        }
        if (this.mode == 'erase' && isDrawing) {
          let qingx = e.offsetX
          let qingy = e.offsetY
          this.clearPath.push({x: e.offsetX, y: e.offsetY})
          this.erase(this.canvasDisplay, qingx, qingy)
        }
        e.preventDefault()
      });
      // 鼠标画板松开
      canvas2.addEventListener('pointerup', () => {
        if (!isDrawing) return
        isDrawing = false;
      });
    },
    drawCircle(ctx, x, y, col = 'rgba(0, 255, 0, 0.5)', w, h) {
      ctx.globalCompositeOperation = 'source-over'
      this.canvasDisplay.beginPath();
      this.canvasDisplay.arc(x, y, this.brushSize, 0, Math.PI * 2); // 绘制一个半径为 10 的圆形
      this.canvasDisplay.fillStyle = col; // 绿色半透明
      this.canvasDisplay.fill();
      this.canvasDisplay.closePath();

    },

    clearCanvas() {
      // 清除整个画布
      const canvas = this.$refs.canvasRecord;
      const canvas2 = this.$refs.canvasDisplay;
      // const canvas3 = this.$refs.yesMask
      // this.canvasRecord.clearRect(0, 0, canvas.width, canvas.height);
      this.canvasDisplay.clearRect(0, 0, canvas.width, canvas.height);
      // this.canvasYesMask.clearRect(0, 0, canvas3.width, canvas3.height);
      this.drawnPath = []
      // this.loadImage()
      this.removelDraw()
      this.mode = 'draw'
    },
    updateScale(data) {
      const maxScale = 3; // 最大缩放比例
      const minScale = 0.2; // 最小缩放比例
      if (data) {//放大
        if (this.scale < maxScale) {
          this.scale += 0.2; // 每次缩放的增量
          if (this.scale >= 3) {
            this.scale = 3
          }
        }
      } else {//缩小\
        if (this.scale > minScale) {
          this.scale -= 0.2; // 最小缩放比例
        }
      }
      const imgOr = document.getElementById('imageOrigin');
      const canOr = document.getElementById('canMask');
      imgOr.style.transform = `scale(${this.scale})`;
      canOr.style.transform = `scale(${this.scale})`
    },
    toggleMode(name) {
      this.mode = name;
      name === 'erase' ? this.opacity = 1 : this.opacity = 10
    },
    erase(ctx, x, y, w, h) {
      const brushSize = this.brushSize;
      ctx.globalCompositeOperation = 'destination-out'; // 设置擦拭模式
      ctx.beginPath();
      ctx.arc(x, y, brushSize, 0, Math.PI * 2); // 绘制一个圆形
      ctx.fill(); // 填充圆形，实现擦拭效果
      this.clearRea(x, y)
      // ctx.globalCompositeOperation = 'source-over'; // 恢复默认模式
      if (w && h) {
        const largeWidth = w;
        const largeHeight = h;
        const smallWidth = this.$refs.originImg.width;
        const smallHeight = this.$refs.originImg.height;

        // 计算缩放比例
        const scaleX = smallWidth / largeWidth;
        const scaleY = smallHeight / largeHeight;
        const brushSize = this.brushSize;
        ctx.globalCompositeOperation = 'destination-out'; // 设置擦拭模式
        ctx.beginPath();
        ctx.arc(x, y * scaleY + this.changeNum, brushSize, 0, Math.PI * 2); // 绘制一个圆形
        ctx.fill(); // 填充圆形，实现擦拭效果
        // this.clearRea(x,y)
      }
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.timer = null;
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.mgTitp {
  margin-left: 10px;
  display: inline-block;
  padding: 0 7px;
  background: linear-gradient(to right, rgb(99, 231, 82), rgb(98, 238, 247));
  border-radius: 4px;
  font-size: 12px;
  line-height: 20px;
  color: #000;
  margin-right: 10px;
}

.mg_video_box {
  // height: 400px;
  .mg_video_item {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
    // .videoBox::-webkit-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-moz-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-ms-media-controls {
    //   display: none !important;
    // }
    // .videoBox::-o-media-controls {
    //   display: none !important;
    // }
    .play-btn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: rgba(19, 18, 18, 0.6);
      color: white;
      font-size: 24px;
      border: none;
      border-radius: 50%;
      // padding: 12px 20px;
      cursor: pointer;
      z-index: 10;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    video {
      max-width: 100%; /* 限制宽度不超过容器宽度 */
      max-height: 100%; /* 限制高度不超过容器高度 */
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1); /* 可选，阴影效果 */
      border-radius: 8px; /* 可选，圆角效果 */
    }
  }
}

.draw_scroll {
  background-color: #313338;
  height: calc(100% - 15px);
  overflow-y: auto;
  color: #fff;

  &::-webkit-scrollbar {
    margin-left: 5px !important;
    display: block !important;
    width: 6px !important;
  }

  &::-webkit-scrollbar-thumb {
    height: 30px !important;
    background-color: #777 !important;
    border-radius: 10px !important;
  }

  .draw_list {
    overflow: hidden;
    width: 100%;
    position: relative;

    .draw_list_item {
      padding-bottom: 5px;
      background: #403d38;
      border-left: 2px solid #f0b132;
      margin: 10px 0;

      .text {
        padding: 10px;
        overflow: hidden;
        word-break: break-all;
        white-space: normal;
        line-height: 20px;

        .title {
          font-size: 12px;
          margin-bottom: 10px;

          .info {
            //margin-bottom: 10px;
            margin-bottom: 10px;

            .topic {
              font-size: 14px;
              margin-right: 10px;
            }

            .tag {
              background-color: #5865f280;
              display: inline-block;
              color: #fff;
              font-size: 12px;
              padding: 0 5px;
              border-radius: 4px;
              white-space: nowrap;
            }

            .time {
              color: #707070;
            }

            .avatar {
              width: 40px;
              height: 40px;
              border-radius: 50%;
              margin-right: 7px;
              cursor: pointer;
            }

            .time {
              color: #707070;
              font-size: 12px;
            }
          }

          .more_btn {
            width: 36px;
            height: 24px;
            border-radius: 4px;
            color: #fff;
            font-size: 16px;
            background-color: #1e1f22;
          }

          .delete {
            cursor: pointer;
            margin-left: 8px;
            color: #949ba4;

            img {
              width: 20px;
              height: 20px;
              margin-top: -2px;

              &.share {
                width: 16px;
                height: 16px;
              }
            }
          }
        }

        .desc {
          p {
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            line-clamp: 3;
          }

          .en {
            padding-top: 10px;
            margin-top: 10px;
            color: #999168;
            border-top: 1px solid #555041;
          }
        }
      }

      .big_img {
        margin-top: 10px;

        .el-image {
          width: 100%
        }
      }

      .options {
        .options_list {
          margin-top: 10px;

          .tips_icon {
            width: 14px;
            height: 14px;
            opacity: 0.5;
          }

          span {
            font-size: 13px;
            width: 58px;
            height: 32px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            background: #4e5058;
            margin-left: 8px;
            border-radius: 3px;
            cursor: pointer;

            img {
              width: 18px;
              height: 18px;
            }

            &:hover {
              background: #6e717c;
            }

            &.span {
              width: 100px;

              img {
                margin-right: 5px;
              }
            }

            &.span2 {
              width: 40px;
            }
          }

          //
          .redraw {
            img {
              height: 20px;
              // margin-top: 5px;
            }

            line-height: 32px;
          }

          .btn {
            // flex-grow: 1;
            // height: 32px;
            // line-height: 32px;
            // color: #18a058;
            // background-color: #dbefe4;
            // border-radius: 2px;
            // font-size: 12px;
            // font-weight: bold;
            // text-align: center;
            // cursor: pointer;
            // width: 0;
            &:not(:last-child) {
              margin-right: 0px;
            }

            &.loading {
              opacity: 0.6;

              svg {
                margin-top: -4px;
                vertical-align: middle;
                margin-right: 4px;
                animation: rotate 2s linear infinite;
              }
            }

            &.redraw2 {
              background-color: #f5f6fb;

              img {
                height: 30px;
              }
            }

            &.disabled {
              cursor: not-allowed;
              background-color: #ddd;
              color: #666;
            }
          }

          //
        }
      }
    }
  }
}

.tooltips_text {
  font-size: 14px;
  line-height: 1.7;
}

.create_error {
  width: 220px;
  height: 230px;
  background-color: #fff;
  border-radius: 4px;
  padding: 0 10px;
  padding-top: 28px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_new_btn {
    color: #56b15b;

    .err_succ_text {
      color: #ccc;
    }
  }

  .err_new_tip {
    color: #ccc;
    margin-top: 20px;

    .err_tokf {
      color: red;
    }
  }

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    line-height: 44px;
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding-top: 15px;
  }
}

.defeat_popup {
  //width: 600px;
  width: calc(100vw - 40px);
  box-sizing: border-box;
  padding: 0 30px 36px;
  background-color: #fff;
  border-radius: 10px;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 76px;
    text-align: center;
    color: #000;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_items {
      width: 100%;
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;

      .item_question {
        color: #000 !important;
      }

      .item_answer {
        width: 100%;
        white-space: wrap;
        color: #999;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}

.msg-item-content {
  font-size: 13px;
  line-height: 20px;
  padding-top: 5px;

  &.detail_loading {
    .remove_icon {
      // display: none;
      position: absolute;
      top: 10px;
      right: 10px;
      width: 20px;
      height: 20px;
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-image: url("../img/update_close.png");
      background-color: rgba(100, 100, 100, 0.6);
      cursor: pointer;
      border-radius: 3px;
    }

    .loading_text {
      padding-left: 12px;
      color: #f0b132;
    }
  }
}

.creating_progress {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 330px;

  .progress_bar {
    flex-grow: 1;
    height: 10px;
    border-radius: 5px;
    background-color: #dbefe4;
    margin-right: 6px;

    .progress_line {
      height: 100%;
      background-color: #f0b132;
      border-radius: 5px;
      transition: width 0.3s linear;
    }
  }

  .progress_percent {
    font-size: 12px;
    line-height: 1;
    color: #f0b132;
    white-space: nowrap;
  }
}

.msg_img_wrap {
  max-width: 400px;
  position: relative;
  overflow: hidden;
  display: inline-block;
  // border-radius:5px;
  &:hover {
    .img_footer {
      bottom: 0;
    }
  }

  .msg_img_ele {
    display: block;
    width: 100%;
    cursor: pointer;
  }

  .img_footer {
    position: absolute;
    width: 100%;
    left: 0;
    bottom: -40px;
    height: 40px;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: space-around;
    transition: bottom 0.3s;

    .footer_item {
      cursor: pointer;

      .footer_icon {
        display: inline-block;
        width: 14px;
        height: 14px;
        vertical-align: middle;
        margin-right: 5px;
        background-size: 100% 100%;

        &.download {
          background-image: url("../img/download.png");
        }

        &.preview {
          background-image: url("../img/preview_img.png");
        }

        &.delete {
          background-image: url("../img/remove.png");
        }
      }

      span {
        vertical-align: middle;
        display: inline-block;
        font-size: 14px;
        color: #fff;
      }
    }
  }

  .look_img {
    //display: none;
    //opacity: 0;
    cursor: pointer;
    width: 75px;
    height: 28px;
    position: absolute;
    top: 10px;
    right: 10px;
    border: rgba(88, 101, 242, 0.8) solid 2px;
    background-color: rgba(88, 101, 242, 0.533);
    border-radius: 6px;
    color: white;
    font-size: 12px;
    box-sizing: border-box;
    line-height: 24px;
    text-align: center;
  }
}

.Image_manipulation {
  //width: 500px;
  background-color: #3f3c3a;
  padding: 20px 20px;
  border-radius: 4px;
  position: relative;

  .clear {
    position: absolute;
    top: 0px;
    right: 0px;
    //background-color: #5865f2;
    border: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    .el-icon-error {
      font-size: 20px;
      color: #565658;
    }
  }

  .clear:hover {
    background-color: #343538;
  }
}

.more_list {
  .operate_item {
    height: 28px;
    font-size: 14px;
    color: #949ba4;

    img {
      width: 20px;
      height: 20px;
      margin-top: -2px;
      margin-right: 4px;

      &.share {
        width: 14px;
        height: 14px;
        margin-left: 3px;
        margin-right: 6px;
      }
    }
  }
}

.drowPopB {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: auto;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1500;
  display: flex;
  align-items: center;
  justify-content: center;

  .imgRemovalPopup {
    width: 100%;
    margin-top: 40px;
    padding: 20px 15px;
    //background-color: #000000;
    background-color: rgb(30, 31, 34);
    border-radius: 10px;
    // height: 500px;
    font-size: 14px;
    color: #fafafa;
    overflow: hidden;

    .imgbox_top {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      font-weight: 700;
    }

    .imgbox_center {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      padding: 20px 0;
      position: relative;

      .apply {
        display: flex;

        span {
          display: block;
          width: 100px;
          padding: 8px 0;
          text-align: center;
          background-color: #31374a;
          border-radius: 5px;
          border: 2px solid #31374a;
          cursor: pointer;
        }

        .spancol {
          border: 2px solid #04c066;
        }
      }

      .brush {
        display: flex;
        align-items: center;
        position: relative;
        // .aocText{
        //   position: absolute;
        //   top: -5px;
        //   left: 50%;
        //   transform: translateX(-50%);
        // }
        .addBtn {
          width: 20px;
          height: 20px;
          cursor: pointer;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .slider {
          width: 100px;
          margin: 0 10px;
        }
      }

      .scoBox {
        display: flex;
        justify-content: space-between;
        width: 140px;
      }

      .scoleBox {
        display: flex;
        align-items: center;

        .scoText {
          margin-right: 10px;
        }

        .scoBtn {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          color: #fff;
          background: #919090;
          cursor: pointer;
          margin-right: 10px;
        }
      }

      .clear_btn {
        position: absolute;
        top: 17px;
        right: -20px;

        div {
          padding: 8px 20px;
          margin: 0 20px 0 0;
          text-align: center;
          background-color: #31374a;
          border-radius: 5px;
          border: 2px solid #31374a;
          cursor: pointer;
        }
      }

    }

    .canvas_region {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;
      background: rgb(20, 24, 36);

      .canvas-wrapper {
        position: relative;
        width: calc(100vw - 30px);
        height: 50vh;
        overflow: auto;
        display: flex;
        justify-content: center;
        align-items: center;
        // background-color: #f0f0f0; /* 可选的背景色 */
        // flex-direction: column;
        font-size: 0 !important;

        &::-webkit-scrollbar {
          width: 0px; /* 设置滚动条宽度 */
          height: 0px; /* 设置滚动条高度，对于水平滚动条有效 */
        }
      }

      #imageOrigin {
        position: absolute;
        transform-origin: center; /* 设置缩放中心 */
        transform: scale(1); /* 初始缩放比例 */
        transition: transform 0.3s ease; /* 动画效果 */
        max-width: none !important;
      }

      #canMask {
        position: absolute;
        transform-origin: center;
        transform: scale(1); /* 初始缩放比例 */
        transition: transform 0.3s ease;
      }

      .canvas_box {
        position: relative;
        font-size: 0 !important;
        // width: 600px;
        // height: 600px;
        /* overflow: hidden; */
        display: flex;
        justify-content: center;
        align-items: center;

        .canvas_img {
          // max-width: 600px;
          height: 100%;

        }

        .canvas_imgs {
          // max-width: 600px;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          //border: 1px solid #000;
          // background: transparent;
          background-size: cover; /* 使背景图像覆盖整个canvas */
          background-position: center; /* 将背景图像居中 */
          background-repeat: no-repeat; /* 防止背景图像重复 */
        }
      }

      .brush {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        color: #fafafa;
        font-size: 16px;
        background-color: rgba(0, 0, 0, .6);
        padding: 5px;
        border-radius: 3px;

        .addBtn {
          width: 22px;
          //height: 20px;
          cursor: pointer;
          font-size: 0 !important;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .slider {
          width: 100px;
          margin: 0 10px;
        }

        .Dragging {
          padding: 0 4px;
          border-radius: 3px;
          cursor: pointer;

          &.ok_drag {
            background-color: #616368;
          }

          &:hover {
            background-color: #2b2b2b;
          }
        }
      }

      .scoBox {
        display: flex;
        justify-content: space-between;
        width: 150px;
      }

    }

    .complete_btn {
      padding: 10px 0 0;
      border-top: 1px solid #353639;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-evenly;

      .inp_Redraw {
        //margin-right: 20px;

        input {
          background: #313338 !important;
          white-space: normal;
          border: none;
          resize: none;
          height: 32px;
          padding: 0 0 0 10px;
          border-radius: 3px;
          width: 200px;
          color: #d2d2d3;
        }
      }

      .fulfil_btn {
        //margin: 0 auto;
        cursor: pointer;
        background-color: #5865f2;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        white-space: nowrap;
        user-select: none;
        height: 36px;
        width: 250px;
        border-radius: 4px;
        //margin-left: 20px;
      }
    }
  }
}
</style>